import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import type { ThemeMode } from "@noa/theme";
import type { UiPreferencesStore } from "./ui-preferences.types";

const stateCreator = (
  set: (partial: Partial<UiPreferencesStore>) => void,
  get: () => UiPreferencesStore
): UiPreferencesStore => ({
  showPredefinedTasks: true,
  setShowPredefinedTasks: (value: boolean) => set({ showPredefinedTasks: value }),

  isAppSiderCollapsed: false,
  toggleAppSiderCollapse: () => set({ isAppSiderCollapsed: !get().isAppSiderCollapsed }),

  isRefDocsPanelCollapsed: false,
  toggleRefDocsPanelCollapse: () => set({ isRefDocsPanelCollapsed: !get().isRefDocsPanelCollapsed }),

  themeMode: "light" as ThemeMode,
  setThemeMode: (mode: ThemeMode) => set({ themeMode: mode }),
});

const PERSISTED_STORE_NAME = "persisted-store-ui-preferences";

const persistedStateCreator = persist<UiPreferencesStore>(stateCreator, {
  name: PERSISTED_STORE_NAME,
  storage: createJSONStorage(() => localStorage),
});

export const useUiPreferencesStore = create<UiPreferencesStore>()(
  devtools(persistedStateCreator, { name: PERSISTED_STORE_NAME })
);

export const useShowPredefinedTasks = () => useUiPreferencesStore((state) => state.showPredefinedTasks);
export const useSetShowPredefinedTasks = () => useUiPreferencesStore((state) => state.setShowPredefinedTasks);

export const useIsAppSiderCollapsed = () => useUiPreferencesStore((state) => state.isAppSiderCollapsed);
export const useToggleAppSiderCollapse = () => useUiPreferencesStore((state) => state.toggleAppSiderCollapse);

export const useIsRefDocsPanelCollapsed = () => useUiPreferencesStore((state) => state.isRefDocsPanelCollapsed);
export const useToggleRefDocsPanelCollapse = () => useUiPreferencesStore((state) => state.toggleRefDocsPanelCollapse);

export const useThemeMode = () => useUiPreferencesStore((state) => state.themeMode);
export const useSetThemeMode = () => useUiPreferencesStore((state) => state.setThemeMode);
